import { render, staticRenderFns } from "./powerTarget.vue?vue&type=template&id=ddc734ac&scoped=true&"
import script from "./powerTarget.vue?vue&type=script&lang=js&"
export * from "./powerTarget.vue?vue&type=script&lang=js&"
import style0 from "./powerTarget.vue?vue&type=style&index=0&id=ddc734ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc734ac",
  null
  
)

export default component.exports